
import { DEFAULT_VAT_RATE } from '../../constants';
import { Component, Prop, Mixins } from 'vue-property-decorator';
import { IProductPriceDefaultI18n, IProductPriceOverrideI18n } from './types';
import { I18nMixin } from '../../mixins';
import WLPrice from './WLPrice.vue';

@Component({ components: { WLPrice } })
export default class WLProductPrice extends Mixins(I18nMixin) {
  get defaultVatRate() {
    return DEFAULT_VAT_RATE;
  }

  @Prop()
  public overrideI18n!: IProductPriceOverrideI18n;

  public defaultI18n!: IProductPriceDefaultI18n;

  @Prop()
  private price!: number;

  @Prop()
  private vatRate!: number;

  @Prop({ default: false })
  private isPageBankImprintMobile!: boolean;

  created() {
    this.defaultI18n = {
      vat_included: this.$t('components_plugin.product_page.vat_included'),
    };
  }
}
